module.exports = __webpack_public_path__ + "static/media/06_CORTININHA_SEM_BOJO_LISO_03.670c0f47.jpg";